import {parsePhoneNumber} from 'react-phone-number-input';
import {PhoneNumber} from '../models';

export const convertStringToPhoneNumber = (phoneString: string): PhoneNumber => {
  if (!phoneString?.trim()) {
    return new PhoneNumber({countryCode: '', phoneNumber: ''});
  }
  try {
    const parsed = parsePhoneNumber(phoneString);
    if (parsed != null) {
      return new PhoneNumber({
        countryCode: `+${parsed.countryCallingCode}`,
        phoneNumber: parsed.nationalNumber ?? '',
      });
    }
    return new PhoneNumber({countryCode: '', phoneNumber: phoneString});
  } catch {
    return new PhoneNumber({countryCode: '', phoneNumber: phoneString});
  }
};
